module.exports = __webpack_public_path__ + "static/img/5.b8e1c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/04/5.png
// module id = wx8d
// module chunks = 1